import { compose } from 'redux';

import { FieldType } from 'constants/formGenerator';
import { languagePreferenceOptionsV2 } from 'constants/options';
import { getConditionalArray } from 'utils/data';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { sectionStyles, sectionTitleStyles, textFieldStyles } from '../Declarations.styles';

export const getConfigFields = ({ entityId }) => {
  const modelPath = `[${entityId}].declarations.languagePreference.`;

  return {
    languagePreference: {
      fieldId: 'languagePreference',
      type: FieldType.SELECT,
      nameInModel: `${modelPath}languagePreference`,
      inputProps: {
        options: languagePreferenceOptionsV2,
        placeholder: 'Language Preference',
        label: 'Language Preference',
        customStyles: textFieldStyles,
        disabled: false,
        required: true,
        variant: 'outlined',
      },
    },
    otherLanguagePreference: {
      fieldId: 'otherLanguagePreference',
      type: FieldType.INPUT,
      nameInModel: `${modelPath}otherLanguagePreference`,
      inputProps: {
        maxLength: 50,
        placeholder: 'Other language preference',
        label: 'Other language preference',
        customStyles: textFieldStyles,
        disabled: false,
        required: true,
        variant: 'outlined',
      },
    },
  };
};

export const getConfig = compose(
  fillConfigFieldsWithKeys,
  ({ isOtherLanguageSelected, entityId }) => {
    const languagePreferenceFields = getConfigFields({
      entityId,
    });

    return {
      groups: [
        {
          title: { label: 'Language preference', titleStyles: sectionTitleStyles },
          key: `${entityId}-declarations-language-preference`,
          customStyles: { ...sectionStyles, gap: '24px' },
          type: FieldType.GROUP,
          fields: [
            languagePreferenceFields.languagePreference,

            ...getConditionalArray(isOtherLanguageSelected, [
              languagePreferenceFields.otherLanguagePreference,
            ]),
          ],
        },
      ],
    };
  },
);
